import { Lead } from 'models/Lead';
import {
  LEAD_DRAWER_OPTIONS,
  LeadDrawerOptions,
} from '../../../../../../models';
import {
  PAUSED_LEAD_REPLY_TAB,
  PausedLeadReplyTab,
} from 'models/MixpanelEvents';
import { DealRoom } from 'models/DealRoom';
import { getUserFullName } from 'utils';
import { ReleaseOrderStatus } from 'models/WorkflowConfiguration';

export const getCanReplyInChat = (
  lead: Lead,
  selectedDrawer: LeadDrawerOptions,
) => !!lead?.sessionId && selectedDrawer !== LEAD_DRAWER_OPTIONS.MESSAGES;

export const PAUSED_LEAD_REPLY_TABS: Partial<
  Record<LeadDrawerOptions, PausedLeadReplyTab>
> = {
  [LEAD_DRAWER_OPTIONS.PROFILE]: PAUSED_LEAD_REPLY_TAB.PROFILE,
  [LEAD_DRAWER_OPTIONS.ACTIVITY]: PAUSED_LEAD_REPLY_TAB.ACTIVITY,
  [LEAD_DRAWER_OPTIONS.FILES]: PAUSED_LEAD_REPLY_TAB.FILES,
  [LEAD_DRAWER_OPTIONS.NOTES]: PAUSED_LEAD_REPLY_TAB.NOTES,
};

export const getPausedLeadMixpanelProps = (lead: Lead, dealRoom: DealRoom) => ({
  dealId: dealRoom?._id,
  dealName: dealRoom?.name,
  leadId: lead?._id,
  leadName: getUserFullName(lead?.firstName, lead?.lastName),
});

export const getIsReleaseOrderWaitingOnBroker = (
  releaseOrderStatus: ReleaseOrderStatus,
) => !!releaseOrderStatus?.isPaused || !!releaseOrderStatus?.isAwaitingReaction;
